export const CookieKeys = {
    auth_token: "token",
    referral_key: "refKey",
    referral_user: "refUser",
    referral_name: "refName",
    business_key: "businessKey",
    business_user: "businessUser",
    business_name: "businessName",
    follow_popup_closed: "follow_popup_closed",
    paypal_pending_plan_change: "paypal_pending_plan_change",
    paypal_selected_items: "paypal_selected_items",
    landing_page: "authory_landing_page",
    first_touch_channel: "authory_first_touch_channel",
    signup_selected_plan: "authory_signup_selected_plan"
};

export const COOKIE_TOKEN_PATH = "/";
export const COOKIE_TOKEN_AGE = 10 * 365 * 24 * 60 * 60;

/** The plan selected on the pricing page is short-lived: it only needs to survive the
 *  hop into signup, so it expires after 30 minutes. */
export const COOKIE_SELECTED_PLAN_AGE = 30 * 60;
